import { KYMW7400Component } from './kymw7400.component';

import type { RememberGoodsInfo } from './vo/remember-goods-info.model';
import type { GetRememberGoodsListCondition } from './vo/get-remember-goods-list-condition.model';

/** 「忘れず注文商品登録画面」ID */
export const REGISTER_PAGE_ID = 'kymw/7402';

/**
 * 忘れず注文商品一覧画面 の値を管理するクラス
 *
 * @export KYMW7400Model
 * @class KYMW7400Model
 */
export class KYMW7400Model {
  kymw7400Component: KYMW7400Component;

  // 検索条件
  /** 受注企画回 */
  orderReceptionCatalog: string = '';
  /** 配達企画回 */
  deliveryCatalog: string = '';
  /** 注文コード */
  orderNum: string = '';
  /** 部門 */
  classCode: string = '';
  /** バイヤーコード */
  buyerCode: string = '';
  /** アイテムコード */
  itemCode: string = '';
  /** Ｐコード */
  pCode: string = '';
  /** 商品名 */
  guideGoodsName: string = '';
  /** 規格名 */
  guideStandardName: string = '';

  // 商品検索条件 画面保持用
  searchCondition:GetRememberGoodsListCondition = {} as GetRememberGoodsListCondition;

  // 商品一覧表示用
  currentPageNo: number = 1;
  endPageNo: number = 1;
  totalNum: number = 0;
  startDispNum: number = 0;
  endDispNum: number = 0;

  // 画面表示用の商品一覧
  viewRememberGoodsList: RememberGoodsInfo[] = [] as RememberGoodsInfo[];
  // 右クリックで選択された商品情報
  selectedRememberGoods: RememberGoodsInfo = {} as RememberGoodsInfo;

  // 非活性フラグ
  isDisabledContextMenu: boolean = false;
}
